import { ThunkAction } from "redux-thunk";
import { action } from "typesafe-actions";
import { IStoreState } from "../../initialStoreState";
import { AnyAction } from "redux";
import { api } from "../../../api/api";
import {
  saveLoaderCompleted,
  saveLoaderProgress,
  showMessage,
} from "../../messages/messagesActions";
import { IHabitationalApplication } from "../../habitationalPolicy/habitationalApplication/habitationalApplicationNew.types";
import { endPoints } from "../../../constants/endPoints";

export const FETCH_LEAD_HABITATIONAL_APPLICATION_PROGRESS =
  "FETCH_LEAD_HABITATIONAL_APPLICATION_PROGRESS";
export const FETCH_LEAD_HABITATIONAL_APPLICATION_SUCCESS =
  "FETCH_LEAD_HABITATIONAL_APPLICATION_SUCCESS";
export const FETCH_LEAD_HABITATIONAL_APPLICATION_FAILED =
  "FETCH_LEAD_HABITATIONAL_APPLICATION_FAILED";
export const CLEAR_LEAD_HABITATIONAL_APPLICATION_STATE =
  "CLEAR_LEAD_HABITATIONAL_APPLICATION_STATE";

export const fetchLeadHabitationalApplicationProgress = () =>
  action(FETCH_LEAD_HABITATIONAL_APPLICATION_PROGRESS);
export const fetchLeadHabitationalApplicationSuccess = (
  data: IHabitationalApplication
) => action(FETCH_LEAD_HABITATIONAL_APPLICATION_SUCCESS, { data });
export const fetchLeadHabitationalApplicationFailed = () =>
  action(FETCH_LEAD_HABITATIONAL_APPLICATION_FAILED);
export const clearLeadHabitationalApplicationState = () =>
  action(CLEAR_LEAD_HABITATIONAL_APPLICATION_STATE);

export const fetchLeadHabitationalApplication =
  (
    leadId: string,
    incrementalNumber: number
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchLeadHabitationalApplicationProgress());
      const res = await api.get(
        `${endPoints.leadApplications.getHabitationalApplication}?lead_id=${leadId}&incremental_number=${incrementalNumber}`
      );
      const data: IHabitationalApplication[] = res.data.data;
      if (data.length > 0) {
        dispatch(fetchLeadHabitationalApplicationSuccess(data[0]));
      } else {
        dispatch(fetchLeadHabitationalApplicationFailed());
      }
    } catch (err: any) {
      dispatch(fetchLeadHabitationalApplicationFailed());
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

export const upsertLeadHabitationalApplication =
  (
    data: IHabitationalApplication,
    leadId: string,
    onCallback: (isSuccess: boolean, incrementalNumber?: number | null) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(saveLoaderProgress());
      const { customer_id, customer_policy_id, ...restData } = data as any;
      const res = await api.post(
        endPoints.leadApplications.upsertHabitationalApplication,
        {
          ...restData,
          lead_id: leadId,
          incremental_number: data.incremental_number,
        }
      );
      const returnedIncrementalNumber =
        res.data.data?.incremental_number ?? null;
      onCallback(true, returnedIncrementalNumber);
      dispatch(
        showMessage({
          type: "success",
          message: "Habitational application saved successfully!",
          displayAs: "snackbar",
        })
      );
      dispatch(fetchLeadHabitationalApplicationSuccess(data));
    } catch (err: any) {
      onCallback(false);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };
